import { useNavigate } from "react-router-dom";
import { Instagram } from "lucide-react";

const ScrollLink = ({ to, children, className }: { to: string; children: React.ReactNode; className?: string }) => {
  const navigate = useNavigate();
  return (
    <a
      href={to}
      className={className}
      onClick={(e) => {
        e.preventDefault();
        navigate(to);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      {children}
    </a>
  );
};

const footerNavLinks = [
  { label: "דף הבית", to: "/" },
  { label: "הקורסים", to: "/offer" },
  { label: "אודות", to: "/about" },
  { label: "שירותים", to: "/services" },
  { label: "צור קשר", to: "/contact" },
];

const FooterSection = () => (
  <footer className="px-6 py-8 border-t border-border bg-muted/30" dir="rtl">
    <div className="max-w-3xl mx-auto text-center space-y-4">
      <nav className="flex items-center justify-center gap-4 flex-wrap">
         {footerNavLinks.map((link) => (
          <ScrollLink
            key={link.to}
            to={link.to}
            className="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            {link.label}
          </ScrollLink>
        ))}
      </nav>
      <div className="h-px bg-border" />
      <p className="text-muted-foreground text-sm">
        © 2026 Think in Line. All rights reserved. (לחשוב בקו - אלון וייס, Ph.D)
      </p>
      <div className="flex items-center justify-center gap-4 text-muted-foreground text-xs">
        <a href="/privacy" className="hover:text-foreground transition-colors">מדיניות פרטיות</a>
        <a href="/terms" className="hover:text-foreground transition-colors">תנאי שימוש</a>
      </div>
      <div className="flex items-center justify-center gap-5 pt-2">
        <a href="https://www.instagram.com/think_inline/" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition-opacity">
          <Instagram size={28} className="text-orange-500" />
        </a>
      </div>
    </div>
  </footer>
);

export default FooterSection;
